import 'view/css/sw-worker.css';

import moment from 'moment';
import { useState, useEffect } from 'react';

import API from 'service/api';
import Util, { Data } from 'service/util';

import Form from 'component/Form';
import Loading from 'component/Loading';
import NoData from 'component/NoData';
import LocationSelect from 'component/dropdown/LocationSelect';
import PopMessage from 'component/pop-msg/PopMessage';
import DatePicker from 'react-datepicker';
import SearchableList from 'component/dropdown/SearchableList';

const today = Util.getToday();

const WorkerCard = ({location, worker, list, onUpdated}) => {
  const [effect_dtm, setHandoverDate] = useState(null);
  const [ho_worker, setHandoverWorker] = useState(null);

  const submit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let new_id = parseInt(ho_worker?.id, 10);

    if (!ho_worker) {
      PopMessage.show('請先選擇工人', '輸入錯誤', 'danger');
      return false;
    }

    if (worker.id == new_id) {
      PopMessage.show('不能是相同的工人', '輸入錯誤', 'danger');
      return false;
    }

    let dto = {
      srv_dis: location.srv_dis,
      srv_loc: location.srv_loc,
      old_id: worker.id,
      new_id,
      effect_dtm
    };

    API.switchWorker(dto).then(resp => {
      if (!resp.success)
        PopMessage.show(resp.msg, '存取失敗', 'danger');
      else {
        PopMessage.show('已更新資料', '成功', 'success');
        onUpdated();
      }
    });

    return false;
  }

  const getColor = () => {
    if (!worker.max_end || moment(worker.max_end).isSameOrAfter(today)) return 'blue';
    return 'gray';
  }

  return (
    <Form className="sw-worker box" onSubmit={submit}>
      <h4 className={`box-head ${getColor()}`}
          title={worker.worker_code}>{worker.display_name} ({worker.id})</h4>
      <div className="box-body">
        <div>
          <label className="field">
            <strong>最早工作日</strong>
            <span>{ Util.ShortDate(worker.min_start) }</span>
          </label>
          <label className="field">
            <strong>最後工作日</strong>
            <span>{ Util.ShortDate(worker.max_end) }</span>
          </label>
        </div>
        <div>
          <label className="field">
            <strong>交接同事</strong>
            <SearchableList value={ho_worker} items={list}
              withDefault={{id: null, name: ' 請選擇 - '}}
              filter={(w,v)=> -1<`${w.id}||${w.cd}||${w.name}`.toUpperCase().indexOf(v.toUpperCase())}
              getTitle={w=>w.id}
              getDesc={w=>w.name}
              onChange={setHandoverWorker}
            />
          </label>
          <label className="field">
            <strong>交接日期</strong>
            <DatePicker required dateFormat="yyyy-MM-dd"
              selected={effect_dtm} onChange={setHandoverDate} />
          </label>
        </div>
        <div className="action-panel">
          <span className="dummy"></span>
          <button className="btn blue">更新服務</button>
        </div>
      </div>
    </Form>
  );
}


const SwitchWorkerView = (props) => {

  const [ location, setLocation ] = useState(Data.location[0]);
  const [ loc_workers, setLocWorkers ] = useState(null);
  const [ all_workers, setWorkers ] = useState(null);

  const refresh = () => {
    setLocWorkers(null);
    API.getServingWorkers(location).then(resp => {
      if (!resp.success)
        PopMessage.show(resp.msg, '讀取失敗', 'danger');
      else
        setLocWorkers(resp.msg);
    });
  }

  const onSetLocation = (cd_dis,id_loc,o_loc) => {
    setLocation(o_loc);
  }

  useEffect(() => {
    API.getWorkerList().then(data => {
      setWorkers(data);
    });
  }, []);
  useEffect(() => {
    refresh();
  }, [location]);

  let ready = !!loc_workers && !!all_workers;
  if (!ready) return (<>
    <h1>其他管理 - 工人交接</h1>
    <Loading />
  </>);

  return <>
    <h1>其他管理 - 工人交接</h1>
    <div className="row">
      <LocationSelect labelClass="field-row"
        district={location.srv_dis}
        location={location.srv_loc}
        onUpdate={onSetLocation} />
    </div>
    <div className="switch-worker-view">
      <div className="sw-collection">
        { loc_workers.length<1
          ? <NoData />
          : loc_workers.map(w =>
              <WorkerCard key={w.id} worker={w}
                list={all_workers} location={location}
                onUpdated={refresh} />
            )
        }
      </div>
    </div>
  </>

}

export default SwitchWorkerView;

